import React, { useEffect, useState } from 'react';
import styles from './ProfileImageUploader.module.css';
import { Camera, TrashIcon } from '../../../Assets/icons';
const ProfileImageUploader = ({ fallback = '', onUpload, profileImage }) => {
  const [image, setImage] = useState(null);
  const [error, setError] = useState('');

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (file && file.type.startsWith('image/')) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
        setError('');
        if (onUpload) onUpload(reader.result); // Pass the uploaded image to the parent
      };
      reader.readAsDataURL(file);
    } else {
      setError('Please upload a valid image file.');
    }
  };

  const handleRemoveImage = () => {
    setImage(null);
    if (onUpload) onUpload(null); // Pass null to indicate no image
  };

  useEffect(() => {
    setImage(profileImage);
  }, []);
  return (
    <div className={styles.uploader}>
      <div className={styles.wrapper}>
        <div className={styles.preview}>
          {image ? (
            <img src={image} alt="Preview" className={styles.image} />
          ) : (
            <h2 className={styles.fallback}>{fallback}</h2>
          )}
        </div>
        <label className={styles.uploadButton}>
          <Camera />
          <input
            type="file"
            accept="image/*"
            onChange={handleImageUpload}
            className={styles.input}
          />
        </label>
        {/* Remove button */}
        {/* {image && (
          <button className={styles.removeButton} onClick={handleRemoveImage}>
            <TrashIcon color="#fff" />
          </button>
        )} */}
      </div>
      <div className={styles.controls}></div>
      {error && <p className={styles.error}>{error}</p>}
    </div>
  );
};

export default ProfileImageUploader;
